<div class="background-color-white" [class.no-bottom-border]="!bottomBorder">
    <ng-content></ng-content>
</div>
